import { render, staticRenderFns } from "./ChangeUserPermissions.vue?vue&type=template&id=c352b6a4&"
import script from "./ChangeUserPermissions.vue?vue&type=script&lang=js&"
export * from "./ChangeUserPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports